import React from 'react';
import useTranslation from '@src/hooks/useTranslation';

import useCurrentCourse from '@src/hooks/useCurrentCourse';

import HtmlParser from '@src/components/common/htmlParser';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';

const CourseIntroduction = (): JSX.Element => {
	const { t } = useTranslation();
	const { currentCourse: { intro } } = useCurrentCourse();

	return (
		<BlockWrapper id="course_introduction">
			<Header text={t('course:information:course_introduction')} />
			<HtmlParser html={intro} isCourse />
		</BlockWrapper>
	);
};

export default CourseIntroduction;
